import { render, staticRenderFns } from "./GenericPageDisplayModal.vue?vue&type=template&id=a8e4d01e&scoped=true&"
import script from "./GenericPageDisplayModal.vue?vue&type=script&lang=js&"
export * from "./GenericPageDisplayModal.vue?vue&type=script&lang=js&"
import style0 from "./GenericPageDisplayModal.vue?vue&type=style&index=0&id=a8e4d01e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a8e4d01e",
  null
  
)

export default component.exports